function Logo({ className }: { className?: string }) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			viewBox="0 0 36 36"
		>
			<defs>
				<mask id="imHandWriting" fill="#fff">
					<path d="M0 35.085h205.763V0H0z"></path>
				</mask>
			</defs>
			<path
				d="M17.497 35.39C7.834 35.39 0 27.536 0 17.847 0 8.16 7.834.305 17.497.305S34.993 8.16 34.993 17.847c0 9.69-7.833 17.543-17.496 17.543z"
				fill="#942d0b"
			></path>
			<path
				d="M7.172 11.16c-.856-1.32-2.145-2.593-.845-3.862.724-.707 1.65-.171 2.243.368 2.978 2.708-.536 6.2-1.043 9.173-.378 2.219-.297 12.76 3.54 7.906 1.41-1.782 2.536-4.141 4.763-5.013 1.693-.661.95 5.196 3.19 4.451 1.245-.414 2.208-2.175 3.146-3.036 1.09-1.002 3.204.634 4.09 1.31 1.269.969 1.916 2.69 2.63 4.068.886 1.71 2.087 3.045 3.56 4.27-.544-.452.978-4.081 0-4.896-2.995-2.491-3.777-6.495-6.806-8.806-1.767-1.35-3.016-1.426-4.441.133-1.062 1.161-2.674 3.48-3.51 1.041-.937-2.735-1.37-4.63-4.02-1.854-.97 1.018-3.289 5.84-4.943 4.732-.484-.324-.492-1.994-.81-.67.287-1.192.923-2.343 1.418-3.457.678-1.525 1.133-3.105 1.23-4.776.188-3.21.062-6.833-1.994-9.472C6.474.08 5.115 4.663 4.994 6.07c-.304 3.53.097 6.8 2.048 9.81-.311-.48.839-3.626.13-4.72"
				fill="#fff"
				mask="url(#imHandWriting)"
			></path>
		</svg>
	)
}

function LogoWithName({ className }: { className?: string }) {
	return (
		<span className={className}>
			<img
				src="/img/im-logo-white-text.webp"
				alt="Internetmedicin logo"
				className="hidden dark:block"
			/>
			<img
				src="/img/im-logo-black-text.webp"
				alt="Internetmedicin logo"
				className="dark:hidden"
			/>
		</span>
	)
}

export { Logo, LogoWithName }
